import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import {
  assignedProgramRequest,
  markAsCompleteRequest,
} from "../../../store/slices/selfSlice";
import { useParams } from "react-router-dom";

const ContentPreviewIFrame = ({
  previewUrl,
  setPreviewUrl,
  setCompleteManually,
  completeManually,
  markAsCompleteRequest,
  object,
  action,
  requesting,
  error,
  assignedProgramRequest,
}) => {
  const intl = useIntl();

  const params = useParams();

  useEffect(() => {
    if (action === "mark-as-complete-request" && !requesting && !error) {
      setPreviewUrl(null);
    }
  }, [action, error, requesting]);

  useEffect(() => {
    setCompleteManually(false);
    assignedProgramRequest({
      id: params.id,
    });
  }, [previewUrl]);

  const handleMarkAsComplete = () => {
    markAsCompleteRequest({ id: object.id });
  };

  return (
    <div
      className={`edexlms-lo-preview ${
        !previewUrl?.includes("scorm") ? "mark-complete" : ""
      }`}
      width="100%"
      height="100%"
      style={{ display: previewUrl ? "block" : "none" }}
    >
      {(previewUrl && (
        <>
          <div
            data-testid="preview-close"
            className="edexlms-lo-preview-close"
            onClick={() => setPreviewUrl(null)}
          >
            <i className="close pi pi-times" style={{ fontSize: "1.5rem" }} />
          </div>
          <div
            className="edexlms-lo-preview-footer flex align-items-center gap-3 justify-content-start"
            style={{
              marginLeft: "10px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            {(!previewUrl?.includes("scorm") && (
              <>
                <div data-testid="manual-complete">
                  <Checkbox
                    name="manual-complete"
                    onChange={(e) => setCompleteManually(e.checked)}
                    checked={completeManually}
                  ></Checkbox>
                  <label htmlFor="manual-complete" className="ml-2">
                    {intl.formatMessage({ id: "complete_manually" })}
                  </label>
                </div>
                <Button
                  disabled={!completeManually}
                  label={intl.formatMessage({ id: "mark_as_completed" })}
                  onClick={handleMarkAsComplete}
                  outlined
                  size="small"
                />
              </>
            )) ||
              null}
          </div>
          <iframe
            src={`${new URL(previewUrl, process.env.REACT_APP_URL).toString()}`}
            title="player"
          />
        </>
      )) ||
        null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  program: state.self.program,
  enterprise: state.global.enterprise,
  token: state.auth.session.accessToken,
  action: state.self.action,
  error: state.self.error,
  requesting: state.self.requesting,
});

const mapDisptachToProps = (dispatch) => ({
  assignedProgramRequest: (data) => dispatch(assignedProgramRequest(data)),
  markAsCompleteRequest: (data) => dispatch(markAsCompleteRequest(data)),
});

export default connect(
  mapStateToProps,
  mapDisptachToProps
)(ContentPreviewIFrame);
